export const wordsMap = {
  'accelerlist' : 'AccelerList',
  'seller central' : 'Seller Central',
  'fba' : 'FBA',
  'mf' : 'MF'
}